export default __webpack_public_path__ + "static/media/3.f92cd16f.jpg";